"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "How long does the recovery process typically take?",
  answer: "Timelines vary based on the complexity of the case and the movement of assets across the blockchain. While forensic tracing can often be completed within 7 to 14 business days, the legal recovery phase through exchanges or authorities typically takes 4 to 12 weeks. We provide real-time updates through our secure client portal."
}, {
  question: "What are your professional service fees?",
  answer: "We operate with a transparent fee structure consisting of a forensic evaluation fee and a success-based recovery percentage. This ensures our interests are fully aligned with yours. Detailed cost breakdowns are provided after our initial assessment of the transaction volume and asset viability."
}, {
  question: "Can you recover assets from lost hardware wallet seeds?",
  answer: "Yes. Our London-based laboratory specializes in physical device forensics. If you have a damaged Ledger, Trezor, or have lost access to your PIN, we utilize advanced cryptographic extraction techniques to attempt seed recovery. We maintain strict air-gapped security protocols throughout this process."
}, {
  question: "Is the recovery of stolen cryptocurrency guaranteed?",
  answer: "While we maintain one of the industry's highest success rates through advanced blockchain forensics, no ethical firm can guarantee 100% recovery. Success depends on the speed of reporting and whether the assets have been moved to regulated exchanges. We provide a realistic probability score before accepting any case."
}, {
  question: "Do you require my private keys or seed phrases?",
  answer: "Absolutely not. The London Blockchain Centre will never ask for your private keys, recovery seeds, or passwords. We operate strictly through public ledger analysis and authorized legal channels. We advise all clients to never share their credentials with anyone claiming to be a recovery agent."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="50655" id="common-questions" className="bg-background py-24 text-foreground dark">
      <div ref={ref} className={cn("mx-auto w-full max-w-[72rem] px-6 md:px-12 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="mb-16 text-center">
          <h2 className="text-primary text-4xl font-bold leading-[1.1] md:text-5xl tracking-tight uppercase">
            Forensic Investigation FAQ
          </h2>
        </div>

        <div className="mx-auto max-w-4xl">
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-primary/20 last:border-0 data-[state=open]:bg-primary/5 transition-all duration-300" data-index={i}>
                <AccordionTrigger className="text-foreground hover:text-primary hover:no-underline py-6 text-left text-xl font-semibold leading-[1.4] transition-colors [&_svg]:size-6 [&_svg]:text-primary [&_svg]:stroke-[2.5px]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base font-sans leading-[1.6] pb-6 transition-all duration-200 ease-out">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}